import { goToInnerSite } from '@/navigation/CSR/goToInnerSite'
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'

interface Redirect {
  href: string
  target: string
}

const hrefHasProtocol = (href: string) =>
  href.includes('http://') || href.includes('https://')

const useRedirectCtrls = (router: AppRouterInstance) => {
  const onInnerRedirect = (redirect: Redirect) =>
    goToInnerSite(router, redirect.href)

  const onOutsideRedirect = (redirect: Redirect) => {
    window.location.href = redirect.href
  }

  return {
    onRedirect: (redirect: Redirect) => {
      if (hrefHasProtocol(redirect.href)) {
        onOutsideRedirect(redirect)
      }
      onInnerRedirect(redirect)
    },
  }
}
export default useRedirectCtrls
